export default __webpack_public_path__ + "static/media/SCCC-Privacy-Policy-for-Customer-EN.586ca65d.pdf";